import { NavLink, Outlet, useNavigate } from "react-router";
import { setToken } from "../lib/auth";

export default function Layout() {
  const nav = useNavigate();
  function logout() {
    setToken(null);
    nav("/login", { replace: true });
  }
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-slate-800 bg-slate-900/60 backdrop-blur sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-6">
          <div className="font-semibold tracking-tight">
            <span className="text-rainfall-accent">Rainfall</span>
            <span className="text-slate-500"> · admin</span>
          </div>
          <nav className="flex gap-1 text-sm">
            <Tab to="/overview" label="Overview" />
            <Tab to="/library"  label="Library" />
            <Tab to="/jobs"     label="Jobs" />
          </nav>
          <div className="ml-auto">
            <button
              onClick={logout}
              className="text-xs text-slate-400 hover:text-slate-200 px-2 py-1"
            >
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl w-full mx-auto px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}

function Tab({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `px-3 py-1.5 rounded-md transition-colors ${
          isActive ? "bg-slate-800 text-slate-100" : "text-slate-400 hover:text-slate-100"
        }`
      }
    >
      {label}
    </NavLink>
  );
}
